import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { Loader2 } from "lucide-react";

import { Turnstile } from "@marsidev/react-turnstile";
import { CLOUDFLARE_SITEKEY } from "@/utils/constants";
import { Link } from "@tanstack/react-router";

import { createFileRoute } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { ApiService } from "@/services/api-service";

export const Route = createFileRoute("/auth/_layout/forgot-password")({
  component: ForgotPassword,
});

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const forgotPasswordMutation = useMutation({
    mutationFn: () => ApiService.forgotPassword(email, captchaToken!),
  });

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!captchaToken) return;
    forgotPasswordMutation.mutate();
  };

  return (
    <div className="max-w-md w-full">
      <Card className=" shadow-2xl rounded-4xl">
        <CardContent className="pt-6">
          <form onSubmit={handleResetPassword} className="space-y-4 mb-4">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium mb-1 font-satoshi"
              >
                Email
              </label>
              <Input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-neutral-25 pr-10 text-xs placeholder:text-[12px] sm:placeholder:text-xs font-satoshi"
              />
            </div>

            <Turnstile
              siteKey={CLOUDFLARE_SITEKEY}
              onSuccess={(token) => {
                setCaptchaToken(token);
              }}
            />
            <Button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 text-white flex items-center justify-center gap-2 font-satoshi"
              disabled={forgotPasswordMutation.isPending}
            >
              {forgotPasswordMutation.isPending ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                "Send Reset Link"
              )}
            </Button>
            {forgotPasswordMutation.isSuccess && (
              <p className="text-sm text-green-600 mt-2 font-satoshi">
                If an account with that email exists, we've sent a reset link.
              </p>
            )}

            {forgotPasswordMutation.isError && (
              <p className="text-sm text-red-600 mt-2 font-satoshi">
                Something went wrong. Please try again.
              </p>
            )}
          </form>
          <div className="flex flex-col">
            <Link
              to="/auth/login"
              className="text-xs underline text-secondary-700 font-satoshi"
              search={{
                validate: undefined,
              }}
            >
              Back to login
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
